<template>
  <v-card class="card-container">
    <v-dialog v-model="unidadeEditDialog" max-width="700">
      <v-card class="pa-4" :key="unidadeEditKey">
        <h2 class="text-center">Metas da unidade</h2>

        <v-card outlined class="mx-1 my-4 pa-4">
          <v-row class="ma-0" dense>
            <v-col cols="12">
              <h3>Tempo atendimento / Resolução</h3>
            </v-col>
            <v-col class="pb-0" cols="12" sm="6" md="6" lg="6">
              <label class="label">{{
                $t('Tempo atendimento equip. criticidade baixa')
              }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentUnidade.serviceTimeEquipmentLowCriticality"
                v-mask="['##:##']"
                placeholder="Hora/Min"
                name="serviceTimeEquipmentLowCriticality"
                outlined
                class="primary-input"
                :rules="serviceTimeRules"
              ></v-text-field>
            </v-col>
            <v-col class="pb-0" cols="12" sm="6" md="6" lg="6">
              <label class="label">{{
                $t('Tempo resolução equip. criticidade baixa')
              }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentUnidade.resolutionTimeEquipmentLowCriticality"
                type="number"
                :placeholder="$t('Horas')"
                name="resolutionTimeEquipmentLowCriticality"
                outlined
                class="primary-input"
                :min="0"
                v-mask="['###']"
              ></v-text-field>
            </v-col>
            <v-col class="pb-0" cols="12" sm="6" md="6" lg="6">
              <label class="label">{{
                $t('Tempo atendimento equip. criticidade média')
              }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentUnidade.serviceTimeEquipmentMediumCriticality"
                v-mask="['##:##']"
                placeholder="Hora/Min"
                name="serviceTimeEquipmentMediumCriticality"
                outlined
                class="primary-input"
                :rules="serviceTimeRules"
              ></v-text-field>
            </v-col>
            <v-col class="pb-0" cols="12" sm="6" md="6" lg="6">
              <label class="label">{{
                $t('Tempo resolução equip. criticidade média')
              }}</label>
              <v-text-field
                hide-details="auto"
                v-model="
                  currentUnidade.resolutionTimeEquipmentMediumCriticality
                "
                type="number"
                :placeholder="$t('Horas')"
                name="resolutionTimeEquipmentMediumCriticality"
                outlined
                class="primary-input"
                :min="0"
                v-mask="['###']"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <label class="label">{{
                $t('Tempo atendimento equip. criticidade alta')
              }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentUnidade.serviceTimeEquipmentHighCriticality"
                v-mask="['##:##']"
                placeholder="Hora/Min"
                name="serviceTimeEquipmentHighCriticality"
                outlined
                class="primary-input"
                :rules="serviceTimeRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <label class="label">{{
                $t('Tempo resolução equip. criticidade alta')
              }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentUnidade.resolutionTimeEquipmentHighCriticality"
                type="number"
                placeholder="Horas"
                name="resolutionTimeEquipmentHighCriticality"
                outlined
                class="primary-input"
                :min="0"
                v-mask="['###']"
              ></v-text-field>
            </v-col>

            <v-col class="pb-0" cols="12" sm="6" md="6" lg="6">
              <label class="label">{{
                $t('Tempo atendimento setor urgência baixa')
              }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentUnidade.serviceTimeSupplierLowCriticality"
                v-mask="['##:##']"
                placeholder="Hora/Min"
                name="serviceTimeSupplierLowCriticality"
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>
            <v-col class="pb-0" cols="12" sm="6" md="6" lg="6">
              <label class="label">{{
                $t('Tempo resolução setor urgência baixa')
              }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentUnidade.resolutionTimeSupplierLowCriticality"
                type="number"
                :placeholder="$t('Horas')"
                name="resolutionTimeSupplierLowCriticality"
                outlined
                class="primary-input"
                :min="0"
                v-mask="['###']"
              ></v-text-field>
            </v-col>
            <v-col class="pb-0" cols="12" sm="6" md="6" lg="6">
              <label class="label">{{
                $t('Tempo atendimento setor urgência média')
              }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentUnidade.serviceTimeSupplierMediumCriticality"
                v-mask="['##:##']"
                placeholder="Hora/Min"
                name="serviceTimeSupplierMediumCriticality"
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>
            <v-col class="pb-0" cols="12" sm="6" md="6" lg="6">
              <label class="label">{{
                $t('Tempo resolução setor urgência média')
              }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentUnidade.resolutionTimeSupplierMediumCriticality"
                type="number"
                :placeholder="$t('Horas')"
                name="resolutionTimeSupplierMediumCriticality"
                outlined
                class="primary-input"
                :min="0"
                v-mask="['###']"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <label class="label">{{
                $t('Tempo atendimento setor urgência alta')
              }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentUnidade.serviceTimeSupplierHighCriticality"
                v-mask="['##:##']"
                placeholder="Hora/Min"
                name="serviceTimeSupplierHighCriticality"
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <label class="label">
                {{ $t('Tempo resolução setor urgência alta') }}
              </label>
              <v-text-field
                hide-details="auto"
                v-model="currentUnidade.resolutionTimeSupplierHighCriticality"
                type="number"
                :placeholder="$t('Horas')"
                name="resolutionTimeSupplierHighCriticality"
                outlined
                class="primary-input"
                :min="0"
                v-mask="['###']"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>

        <v-row class="ma-0">
          <v-col cols="12" class="d-flex justify-end">
            <v-btn
              class="secondary-button"
              depressed
              :loading="unidadeLoading"
              @click="editUnidade"
            >
              Salvar
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <div class="main-toolbar mb-6">
      <div class="icon-back">
        <v-icon large color="white"> mdi-file-chart-outline</v-icon>
      </div>

      <span class="main-toolbar-title">SLA's</span>

      <v-spacer></v-spacer>
    </div>

    <div>
      <v-tabs
        color="secondary"
        v-model="tab"
        :height="40"
        :mobile-break-point="300"
        class="ma-auto"
        icons-and-text
      >
        <v-tabs-slider color="#BBCF20"></v-tabs-slider>
        <v-tab
          :value="0"
          :tab-value="0"
          active-class="activated-tab"
          class="rounded-lg rounded-b-0"
        >
          Instituição
        </v-tab>
        <v-tab
          :value="1"
          :tab-value="1"
          active-class="activated-tab"
          class="rounded-lg rounded-b-0"
        >
          Unidades
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item :value="0">
          <v-card outlined class="mx-1 my-4 pa-4">
            <v-row class="ma-0" dense>
              <v-col cols="12">
                <h3>Metas</h3>
              </v-col>
              <v-col cols="12" sm="6">
                <label class="ml-1"> Meta de resolutividade interna </label>
                <v-text-field
                  v-model="institution.internalResolvingGoal"
                  class="primary-input"
                  suffix="%"
                  outlined
                  hide-details=""
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <label class="ml-1">
                  Meta de preventiva agendada x executada
                </label>
                <v-text-field
                  v-model="institution.preventivScheduledExecutedGoal"
                  class="primary-input"
                  suffix="%"
                  outlined
                  hide-details=""
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <label class="ml-1">
                  Meta de calibrações agendadas x executadas
                </label>
                <v-text-field
                  v-model="institution.calibrationsScheduledPerfomedGoal"
                  class="primary-input"
                  outlined
                  suffix="%"
                  hide-details=""
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <label class="ml-1">
                  Meta de corretivas solicitadas x executadas
                </label>
                <v-text-field
                  v-model="institution.correctionsRequestedExecutedGoal"
                  class="primary-input"
                  suffix="%"
                  outlined
                  hide-details=""
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <label class="ml-1">
                  Meta de segurança elétrica agendada x executada
                </label>
                <v-text-field
                  v-model="institution.electricalSafetyScheduledExecutedGoal"
                  class="primary-input"
                  outlined
                  suffix="%"
                  hide-details=""
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <label class="ml-1">
                  Meta de chamados atendidos no prazo
                </label>
                <v-text-field
                  v-model="institution.callsAnsweredOnTimeGoal"
                  class="primary-input"
                  outlined
                  suffix="%"
                  hide-details=""
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <label class="ml-1">
                  Meta de chamados resolvidos no prazo
                </label>
                <v-text-field
                  v-model="institution.callsResolvedOnTimeGoal"
                  class="primary-input"
                  outlined
                  suffix="%"
                  hide-details=""
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card>

          <v-card outlined class="mx-1 my-4 pa-4">
            <v-row class="ma-0" dense>
              <v-col cols="12">
                <h3>Etapas</h3>
              </v-col>

              <v-col cols="12" sm="6">
                <label class="ml-1"> Aguardando peça </label>
                <v-text-field
                  v-model="institution.waintingForPart"
                  class="primary-input"
                  type="number"
                  outlined
                  suffix="Dias"
                  hide-details=""
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <label class="ml-1"> Aguardando orçamento </label>
                <v-text-field
                  v-model="institution.waintingBudget"
                  class="primary-input"
                  type="number"
                  suffix="Dias"
                  outlined
                  hide-details=""
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <label class="ml-1"> Aguardando avaliação externa </label>
                <v-text-field
                  v-model="institution.waintingExternalAppraisal"
                  class="primary-input"
                  type="number"
                  suffix="Dias"
                  outlined
                  hide-details=""
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <label class="ml-1"> Aguardando aprovação de orçamento </label>
                <v-text-field
                  v-model="institution.waintingBudgetApproval"
                  class="primary-input"
                  type="number"
                  suffix="Dias"
                  outlined
                  hide-details=""
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <label class="ml-1"> Aguardando liberação do setor </label>
                <v-text-field
                  v-model="institution.waitingDepartmentRelease"
                  class="primary-input"
                  type="number"
                  suffix="Dias"
                  outlined
                  hide-details=""
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <label class="ml-1">
                  Aguardando manutenção terceirizada externa
                </label>
                <v-text-field
                  v-model="institution.waitingExternalMaintenance"
                  class="primary-input"
                  type="number"
                  suffix="Dias"
                  outlined
                  hide-details=""
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card>
          <v-card outlined class="mx-1 my-4 pa-4">
            <v-row class="ma-0" dense>
              <v-col cols="12">
                <h3>Custos</h3>
              </v-col>
              <v-col cols="12" sm="6">
                <label class="ml-1">Meta custo evitado</label>
                <v-currency-field
                  v-model="institution.avoidedCostGoal"
                  class="primary-input"
                  suffix="R$"
                  outlined
                  hide-details=""
                ></v-currency-field>
              </v-col>
              <v-col cols="12" sm="6">
                <label class="ml-1">% da meta</label>
                <v-text-field
                  v-model="institution.avoidedCostGoalPercent"
                  class="primary-input"
                  suffix="%"
                  outlined
                  hide-details=""
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card>
          <v-row class="ma-0">
            <v-col cols="12" class="d-flex justify-end">
              <v-btn
                class="secondary-button"
                depressed
                :loading="loading"
                @click="editInstitution"
              >
                Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item :value="1">
          <v-data-table
            :loading="loading"
            :loading-text="$t('Carregando...')"
            :no-data-text="$t('Nenhuma unidade encontrada')"
            :headers="headers"
            :items="unidades"
            class="main-table"
            hide-default-footer
            hide-default-header
            :items-per-page="pageSize"
            :header-props="headerProps"
          >
            <template #header="{ props, on }">
              <thead>
                <tr>
                  <th
                    class="text-center"
                    v-for="header in props.headers"
                    :key="header.value"
                  >
                    <v-simple-checkbox
                      v-if="header.value === 'data-table-select'"
                      v-model="props.everyItem"
                      :indeterminate="props.someItems && !props.everyItem"
                      color="purple"
                      @input="on['toggle-select-all']"
                    ></v-simple-checkbox>

                    <div>
                      <v-hover v-slot="{ hover }">
                        <div>
                          <span>{{ $t(header.text) }}</span>
                          <v-icon
                            v-if="
                              hover &&
                              header.value != 'data-table-select' &&
                              header.value != 'actions'
                            "
                            color="white"
                            class="mx-2"
                            @click="on.sort(header.value)"
                          >
                            {{
                              props.options.sortBy.includes(header.value)
                                ? `mdi-chevron-down`
                                : `mdi-chevron-up`
                            }}
                          </v-icon>
                        </div>
                      </v-hover>
                    </div>
                  </th>
                </tr>
              </thead>
            </template>

            <template #[`item.name`]="{ item }">
              {{ item.name != null ? item.name : $t('Sem registro') }}
            </template>
            <template #[`item.status`]="{ item }">
              {{ item.status == 0 ? 'Ativo' : 'Inativo' }}
            </template>
            <template #[`item.initials`]="{ item }">
              {{ item.initials != null ? item.initials : $t('Sem registro') }}
            </template>

            <template #[`item.cnpj`]="{ item }">
              {{ item.cnpj != null ? item.cnpj : $t('Sem registro') }}
            </template>

            <template #[`item.institution`]="{ item }">
              {{ item.institution != null ? item.institution.name : '' }}
            </template>

            <template #[`item.phone`]="{ item }">
              {{ item.phone != null ? item.phone : $t('Sem registro') }}
            </template>

            <template #[`item.actions`]="{ item }">
              <div class="d-flex justify-center">
                <v-btn
                  class="primary-button"
                  small
                  depressed
                  @click="openEditDialog(item)"
                >
                  Editar
                </v-btn>
              </div>
            </template>
          </v-data-table>
          <div class="pagination">
            <div class="item-pagination block-one">
              <v-menu bottom offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="btn"
                    depressed
                    color="#C0C0C0"
                    small
                  >
                    qtd: {{ pageSize }}
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(size, i) in sizes"
                    :key="i"
                    @click="pageSize = size"
                  >
                    <v-list-item-title>{{ size }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <div class="registros" v-if="totalItensOnPage">
                <span> 1 - {{ totalItensOnPage }} de {{ totalItems }} </span>
              </div>
            </div>

            <div class="item-pagination block-two">
              <v-pagination
                class="pagination-item"
                v-model="page"
                :length="totalPages"
                :total-visible="3"
              ></v-pagination>
            </div>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../services/ApiService'

export default {
  name: 'SLApage',

  data() {
    return {
      serviceTimeRules: [
        (v) => /^\d\d:\d\d/.test(v) || 'Horário em formato inválido',
      ],
      unidadeLoading: false,
      instLoading: false,
      institution: {},
      unidadeEditDialog: false,
      unidadeEditKey: false,
      tab: 0,
      pageSize: 10,
      loading: false,
      unidades: [],
      totalPages: 1,
      totalItems: 0,
      totalItensOnPage: 0,
      page: 1,
      sizes: [10, 30, 90, 180],
      headers: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Unidade',
          align: 'center',
          value: 'name',
        },
        {
          text: 'Status',
          align: 'center',
          value: 'status',
        },
        {
          text: 'Sigla',
          align: 'center',
          value: 'initials',
        },
        {
          text: 'CNPJ',
          align: 'center',
          value: 'cnpj',
        },
        {
          text: 'Cidade',
          align: 'center',
          value: 'city',
        },
        {
          text: 'Telefone',
          value: 'phone',
          align: 'center',
        },
        {
          text: 'Ações',
          value: 'actions',
          sortable: false,
          width: 200,
        },
      ],
      headerProps: {
        sortByText: 'Ordenar por',
      },
      filter: {
        page: 1,
        pageSize: 10,
        Name: null,
        Initials: null,
        Cnpj: null,
        institutionId: 0,
        status: 0,
      },
      institutionId: null,
      apiService: new ApiService(),
      currentUnidade: {},
    }
  },

  created() {
    this.getList()
    this.getInstitution()
  },

  methods: {
    getInstitution() {
      this.instLoading = true

      this.apiService
        .get(`institution/${this.institutionId}`)
        .then((response) => {
          this.institution = response.content
          this.instLoading = false
        })
        .catch(() => {
          this.instLoading = false
        })
    },

    editInstitution() {
      this.loading = true

      const model = {
        institutionId: this.institution.id,
        ...this.institution,
      }

      this.apiService
        .post(`institution/edit-goals`, model)
        .then((response) => {
          const inst = localStorage.getItem('institution')
          const instObj = JSON.parse(inst)

          instObj.waitingBudgetApproval = this.institution.waitingBudgetApproval
          instObj.waitingDepartmentRelease =
            this.institution.waitingDepartmentRelease
          instObj.waitingExternalMaintenance =
            this.institution.waitingExternalMaintenance
          instObj.waintingForPart = this.institution.waintingForPart
          instObj.onsiteOutsourcedMaintenance =
            this.institution.onsiteOutsourcedMaintenance
          instObj.externalOutsourcedMaintenance =
            this.institution.externalOutsourcedMaintenance
          instObj.internalMaintenance = this.institution.internalMaintenance
          instObj.waitingExternalMaintenance =
            this.institution.waitingExternalMaintenance
          instObj.waintingForPart = this.institution.waintingForPart

          localStorage.setItem('institution', JSON.stringify(instObj))
          this.editAvoidedCostGoals()

          this.loading = false
          this.$toast.success('Metas editadas com sucesso!')
        })
        .catch((e) => {
          console.log(e)
          this.loading = false
        })
    },

    editUnidade() {
      this.unidadeLoading = true

      const model = {
        unidadeId: this.currentUnidade.id,
        ...this.currentUnidade,
      }

      this.apiService
        .post(`unidade/edit-goals`, model)
        .then((response) => {
          this.unidadeLoading = false
          this.unidadeEditDialog = false
        })
        .catch(() => {
          this.unidadeLoading = false
        })
    },

    editAvoidedCostGoals() {
      this.avoidedCostLoading = true

      const model = {
        institutionId: this.institution.id,
        avoidedCostGoal: this.institution.avoidedCostGoal,
        avoidedCostGoalPercent: this.institution.avoidedCostGoalPercent,
      }

      this.apiService
        .post(`institution/edit-avoided-cost-goals`, model)
        .then((response) => {
          const inst = localStorage.getItem('institution')
          const instObj = JSON.parse(inst)

          instObj.avoidedCostGoal = this.institution.avoidedCostGoal
          instObj.avoidedCostGoalPercent =
            this.institution.avoidedCostGoalPercent

          localStorage.removeItem('institution')
          localStorage.setItem('institution', JSON.stringify(instObj))

          this.$store.commit('SET_INSTITUTION_USER', JSON.stringify(instObj))

          this.avoidedCostLoading = false
          this.avoidedCostEditDialog = false
        })
        .catch(() => {
          this.avoidedCostLoading = false
        })
    },

    openEditDialog(item) {
      this.currentUnidade = item
      this.unidadeEditKey = !this.unidadeEditKey
      this.unidadeEditDialog = true
    },

    async getList() {
      this.institutionId = JSON.parse(localStorage.getItem('institution')).id
      this.loading = true
      this.filter.institutionId = this.institutionId

      await this.apiService
        .post('unidade/list', this.filter)
        .then((response) => {
          this.totalPages = response.content.pager.totalPages
          this.unidades = response.content.unidades

          this.totalItems = response.content.pager.totalItems
          this.totalItensOnPage = response.content.unidades.length
          this.loading = false
        })
    },
  },

  watch: {
    pageSize() {
      this.filter.pageSize = this.pageSize
      this.getList()
    },

    page() {
      this.filter.page = this.page
      this.getList()
    },
  },
}
</script>

<style></style>
